
//const urlPath = "http://undefined.ddns.net:86"/*deploy*/
//const urlPath = "https://mju-project.herokuapp.com"/*heroku*/
// const urlForgot = "https://mju.undefined.co.th"/*testing*/
const urlForgot = "https://organiclesson.mju.ac.th"
export default urlForgot;